export const DASH_WIDTH = 10;

export default {
  props: {
    x: {
      type: Number,
      default: 0,
    },
    y: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    rotation: {
      type: Number,
      default: 0,
    },
    debug: Boolean,
    // Custom
    innerX: { type: Number, default: undefined },
    innerY: { type: Number, default: undefined },
    innerScaleX: { type: Number, default: undefined },
    innerScaleY: { type: Number, default: undefined },
    innerRotation: { type: Number, default: undefined },
  },
  computed: {
    groupNodeCommonConfig() {
      return {
        x: 0,
        y: 0,
        width: this.width,
        height: this.height,
      };
    },
    groupConfig() {
      return {
        x: this.x,
        y: this.y,
        rotation: this.rotation,
        width: this.width,
        height: this.height,
      };
    },
    rectStroke() {
      return 'green';
    },
    dashOffset() {
      return 0;
    },
    rectConfig() {
      return {
        ...this.groupNodeCommonConfig,
        stroke: this.rectStroke,
        dash: [DASH_WIDTH],
        dashOffset: this.dashOffset,
      };
    },
  },
};
